import axiosInstance from '@/core/api'
import {
	Disable2FA,
	Enable2FA,
	GetTOTPGenerate,
	ResetPassword,
	ResetPasswordResponse,
	ResetTOTP,
} from '../../types'

export const getTOTPGenerate = async (id: string): Promise<GetTOTPGenerate> => {
	const response = await axiosInstance.post<GetTOTPGenerate>(
		`/admin/operators/generate-totp/${id}`,
	)
	return response.data
}

export const enable2FA = async (
	id: string,
	payload: Enable2FA,
): Promise<void> => {
	const response = await axiosInstance.post<void>(
		`/admin/operators/enable-totp/${id}`,
		payload,
	)
	return response.data
}

export const disable2FA = async (
	id: string,
	payload: Disable2FA,
): Promise<void> => {
	const response = await axiosInstance.post<void>(
		`/admin/operators/disable-totp/${id}`,
		payload,
	)
	return response.data
}

export const resetTOTP = async (
	id: string,
	payload: ResetTOTP,
): Promise<void> => {
	const response = await axiosInstance.post<void>(
		`/admin/operators/reset-totp/${id}`,
		payload,
	)
	return response.data
}

export const resetPassword = async (
	payload: ResetPassword,
): Promise<ResetPasswordResponse> => {
	const response = await axiosInstance.patch<ResetPasswordResponse>(
		'/admin/operators/update-me',
		payload,
	)
	return response.data
}
